// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"Menu-module__menuPaper--17r38","menuList":"Menu-module__menuList--2kYtQ"};